<div class="screen">
  <router-outlet></router-outlet>
</div>
<smart-router-animation-wrap [hidden]="!isLoadingActive"></smart-router-animation-wrap>
<div *ngIf="appNotAvailable" class="error-on-init">
  <p>{{'NO_AVAILABLE_APP'|translate}}</p>
</div>
